import { useV2ListPaymentCreditsForAccountQuery } from "@generated";
import { PaymentCreditOption } from "../types/ProjectCredit";

const useListPaymentCredits = () => {

  const { data, isLoading } = useV2ListPaymentCreditsForAccountQuery({
    page: { size: 250 },
  });

  const paymentCredits: PaymentCreditOption[] =
    data?.data?.map((pc: any) => ({
      id: String(pc.id),
      paymentSource: pc.attributes?.["payment-source"] || "",
      description: pc.attributes?.description || "",
      criteria: pc.attributes?.criteria || "",
    })) || [];

  const paymentCreditsMap: Record<
    string,
    { paymentSource: string; description: string; criteria: string }
  > = {};
  paymentCredits.forEach((pc) => {
    paymentCreditsMap[pc.id] = {
      paymentSource: pc.paymentSource,
      description: pc.description,
      criteria: pc.criteria,
    };
  });

  return { paymentCredits, paymentCreditsMap, paymentCreditsLoading: isLoading };
};

export default useListPaymentCredits;
